<template>
  <div class="toolbar-view-group Fuell-ToolbarMultiButton">
    <button
      @click="showDefaultView"
      :class="{'active-left': activeView === 'default'}"
    >
      <span class="Fuell-ToolbarButton--icon">
        <img
          :src="require('@/assets/img/icons/icon-group-default.svg')"
          alt="filter"
        />
      </span>
    </button>
    <button
      @click="showUsersView"
      :class="{'active-right': activeView === 'users'}"
    >
      <span class="Fuell-ToolbarButton--icon">
        <img
          :src="require('@/assets/img/icons/icon-group-users.svg')"
          alt="filter"
        />
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'TransactionsViewGroup',
  props: {
    activeView: {
      type: String,
      default: 'default'
    }
  },
  model: {
    prop: 'activeView'
  },
  methods: {
    showDefaultView () {
      this.$emit('changeView', 'default')
    },
    showUsersView () {
      this.$emit('changeView', 'users')
    }
  }
}
</script>

<style lang="scss" scoped>
.toolbar-view-group {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px!important;
  padding: 0;
  flex-direction: row;

  button {
    height: 100%;

    &.active-left {
      background: var(--fill-main-background);
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08),
        0px 3px 6px rgba(0, 0, 0, 0.03), 0px 5px 10px rgba(0, 0, 0, 0.04),
        0px 10px 18px rgba(0, 0, 0, 0.05), 0px 16px 30px rgba(0, 0, 0, 0.06),
        0px 40px 80px rgba(0, 0, 0, 0.07);
      border-radius: 4px;
    }

    &.active-right {
      background: var(--fill-main-background);
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08),
        0px 3px 6px rgba(0, 0, 0, 0.03), 0px 5px 10px rgba(0, 0, 0, 0.04),
        0px 10px 18px rgba(0, 0, 0, 0.05), 0px 16px 30px rgba(0, 0, 0, 0.06),
        0px 40px 80px rgba(0, 0, 0, 0.07);
      border-radius: 4px;
    }
  }
}
</style>
